"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscoverContentDataType = void 0;
var DiscoverContentDataType;
(function (DiscoverContentDataType) {
    DiscoverContentDataType[DiscoverContentDataType["Route"] = 0] = "Route";
    DiscoverContentDataType[DiscoverContentDataType["Location"] = 1] = "Location";
    DiscoverContentDataType[DiscoverContentDataType["Country"] = 2] = "Country";
})(DiscoverContentDataType || (exports.DiscoverContentDataType = DiscoverContentDataType = {}));
//# sourceMappingURL=DiscoverContentDataType.js.map